/* More specific functions for Hachenbach Articles and Structure */

import { BarcodeFormat, BarcodeScanner, LensFacing } from "@capacitor-mlkit/barcode-scanning";


export const urlToIdent = (url_string: string) => {
    let params = [];
    var url = new URL(url_string);
    var searchStr = url.search.substring(1);
    var values = url.searchParams.values();
    //@ts-ignore
    for (const value of values) params.push(value);

    return { params, searchStr };
}

export const requestPermissions = async () => {
    const { camera } = await BarcodeScanner.requestPermissions();
    return camera === 'granted' || camera === 'limited';
}

export const installGoogleBarcodeScannerModule = async () => {
    await BarcodeScanner.installGoogleBarcodeScannerModule();
}

export const defaultScannerOptions = {
    formats: [BarcodeFormat.QrCode],
    lensFacing: LensFacing.Back
}
